import styled from 'styled-components';

export const CheckboxGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;
